<template>
  <div class="receivable-list">
    <section class="content">
      <section style="margin-bottom: 1%">
        <a-button type="primary" @click="createHandle">
          <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
          {{ $t('新增应收单') }}
        </a-button>
      </section>
      <div class="form-content">
        <a-row :gutter="16" style="margin-top: 15px">
          <a-col :span="6">
            <CommonSelect
              :isBu="true"
              :list="$store.state.settlementBuList"
              :placeholder="$t('结算组织')"
              :code.sync="formData.businessUnitCode"
              @change="searchHandle(1)"
            />
          </a-col>
          <a-col :span="6">
            <a-input
              allow-clear
              v-model.trim="formData.orderSn"
              :placeholder="$t('请输入应收单号')"
            />
          </a-col>
          <a-col :span="6">
            <date-range-picker
              :needhms="false"
              @get_date="chooseBizDate"
              :placeholder="$t(`业务日期`)"
              :start-time="formData.bizDateStart"
              :end-time="formData.bizDateEnd"
            ></date-range-picker>
          </a-col>
          <a-col :span="6">
            <date-range-picker
              :needhms="false"
              @get_date="chooseAccountingDate"
              :placeholder="$t(`记账日期`)"
              :start-time="formData.accountingDateStart"
              :end-time="formData.accountingDateEnd"
            ></date-range-picker>
          </a-col>
          <a-col :span="6">
            <CommonQuerySelect
              api="getAccountDimensionItemList"
              paginate
              :placeholder="$t('客户')"
              :code.sync="formData.customerCode"
              :params="{
                businessUnitCode: formData.businessUnitCode,
                type: 'customer',
              }"
            />
          </a-col>
          <a-col :span="6">
            <SelectDocumentType :docType="docType" :code.sync="formData.orderType" />
          </a-col>
          <a-col :span="6">
            <CommonSelect
              :placeholder="$t('源单类型')"
              :list="sourceOrderTypeList"
              :code.sync="formData.sourceOrderType"
            />
          </a-col>
          <a-col :span="6">
            <a-input
              allow-clear
              v-model.trim="formData.sourceOrderCode"
              :placeholder="$t('请输入源单号')"
            />
          </a-col>
          <a-col :span="6">
            <a-input
              allow-clear
              v-model.trim="formData.salesOrderSn"
              :placeholder="$t('请输入销售单号')"
            />
          </a-col>
          <a-col :span="6">
            <a-input
              allow-clear
              v-model.trim="formData.deliverOrderSn"
              :placeholder="$t('请输入发货单号')"
            />
          </a-col>
          <a-col :span="6">
            <a-select
              v-model="formData.needGenerateVoucher"
              allow-clear
              :placeholder="$t('能否生成凭证')"
              style="width: 100%"
            >
              <a-select-option :value="1">{{ $t('需要') }}</a-select-option>
              <a-select-option :value="0">{{ $t('不需要') }}</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6">
            <a-select
              v-model="formData.voucherGenerated"
              allow-clear
              :placeholder="$t('已生成凭证')"
              style="width: 100%"
            >
              <a-select-option :value="1">{{ $t('是') }}</a-select-option>
              <a-select-option :value="0">{{ $t('否') }}</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6">
            <a-select
              v-model="formData.incomeCostConfirmPushed"
              allow-clear
              :placeholder="$t('是否下推收入成本单')"
              style="width: 100%"
            >
              <a-select-option :value="1">{{ $t('是') }}</a-select-option>
              <a-select-option :value="0">{{ $t('否') }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row :gutter="16" class="mt10">
          <a-col :span="6">
            <a-button @click="searchHandle(1)" class="btnBgc">
              <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
              {{ $t(`查询`) }}
            </a-button>
            <a-button @click="reset">
              <a-icon type="redo" />
              {{ $t(`重置`) }}
            </a-button>
          </a-col>
        </a-row>
      </div>

      <CommonTable
        ref="CommonTableRef"
        :statusList="receivable_order_status"
        :selectedRowKeys.sync="selectedRowKeys"
        :selectedRows.sync="selectedRows"
        :showSelect="true"
        size="small"
        :scroll="{ x: 'max-content' }"
        :columns.sync="tableColumns"
        :data-source="tableData"
        rowKey="id"
        :total="total"
        :loading="tableLoading"
        @select="onSelectChange"
        @search="queryOrderList"
      >
        <template v-slot:header>
          <div class="flex-ct">
            <OperateBtn
              api="operateDoc"
              :text="$t('审核')"
              :params="{
                action: 'check',
                docType: docType,
                idList: selectedRowKeys,
              }"
              :disabled="selectedRowKeys.length === 0"
              @success="searchHandle"
            />
            <PushBtn
              class="ml10"
              pageType="list"
              :docType="docType"
              :selectedRows="selectedRows"
              :disabled="selectedRows.length === 0"
            />
            <VoucherBtn
              class="ml10"
              :docType="docType"
              :selectedRows="selectedRows"
              :disabled="selectedRows.length === 0"
              @close="searchHandle"
            />
            <a-button
              class="ml10"
              type="danger"
              :disabled="selectedRowKeys.length === 0"
              :loading="batchCancelLoading"
              @click="confirmBatchCancel"
            >
              {{ $t('作废') }}
            </a-button>
          </div>
        </template>
        <template v-slot:orderSn="{ text, record }">
          <a @click="viewDetail(record)">{{ text }}</a>
          <a-icon
            type="copy"
            class="ml6"
            style="cursor: pointer; color: #1890ff"
            @click.stop="copyOrderSn(text)"
          />
        </template>
        <template v-slot:amountWithoutTax="{ record }">
          <PriceInput
            :showTxt="true"
            :currency="record.functionalCurrency"
            :value="record.amountWithoutTax"
          />
        </template>
        <template v-slot:taxAmount="{ record }">
          <PriceInput
            :showTxt="true"
            :currency="record.functionalCurrency"
            :value="record.taxAmount"
          />
        </template>
        <template v-slot:receivableAmount="{ record }">
          <PriceInput
            :showTxt="true"
            :currency="record.functionalCurrency"
            :value="record.receivableAmount"
          />
        </template>
        <template v-slot:invoicedAmount="{ record }">
          <PriceInput
            :showTxt="true"
            :currency="record.functionalCurrency"
            :value="record.invoicedAmount"
          />
        </template>
        <!-- 业务单号 -->
        <template v-slot:otherSns="{ record }">
          <div v-if="record.salesOrderSn">
            {{ $t('销售单号') }}:
            <span>{{ record.salesOrderSn }}</span>
          </div>
          <div v-if="record.deliverOrderSn">
            {{ $t('发货单号') }}:
            <span>{{ record.deliverOrderSn }}</span>
          </div>
        </template>
        <template v-slot:sourceOrderCode="{ record }">
          <span>{{ record.sourceOrderCode }}</span>
        </template>
      </CommonTable>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import dateRangePicker from '@component/dateRangePicker'
import PushBtn from '@component/pushBtn'
import { convertKeysToCamelCase, spaceToComma, copy, fetchDocumentMappings } from '@/common'
import { subtract } from '@/common/number'
import SelectDocumentType from '@component/selectDocumentType'

export default {
  name: 'receivableList',
  activated() {
    this.searchHandle()
    this.fetchMappings()
  },
  components: {
    dateRangePicker,
    PushBtn,
    SelectDocumentType,
  },
  data() {
    return {
      docType: 'ReceivableOrder',
      formData: {
        orderSn: undefined,
        orderTimeStart: undefined,
        orderTimeEnd: undefined,
        status: '',
        supplierName: undefined,
        sourceOrderCode: undefined,
        sourceOrderType: undefined,
        salesOrderSn: undefined,
        deliverOrderSn: undefined,
        bizDateStart: undefined,
        bizDateEnd: undefined,
        accountingDateStart: undefined,
        accountingDateEnd: undefined,
        needGenerateVoucher: undefined,
        voucherGenerated: undefined,
        incomeCostConfirmPushed: undefined,
      },
      tableLoading: false,
      batchCancelLoading: false,
      total: 0,
      selectedRowKeys: [],
      selectedRows: [],
      tableData: [],
      mappings: {
        orderType: {},
        sourceOrderType: {},
      },
    }
  },
  computed: {
    ...mapState(['receivable_order_status', 'receivable_order_type']),
    ...mapGetters(['receivableOrderStatusMapping', 'receivableOrderTypeMapping']),
    scrollHeight() {
      return window.innerHeight - 515
    },
    sourceOrderTypeList() {
      if (!this.mappings || !this.mappings.sourceOrderType) return []
      return Object.keys(this.mappings.sourceOrderType).map((key) => ({
        code: key,
        name: this.mappings.sourceOrderType[key],
      }))
    },
    tableColumns() {
      return [
        {
          dataIndex: 'orderSn',
          title: this.$t('应收单号'),
          key: 'orderSn',
          width: 200,
          scopedSlots: { customRender: 'orderSn' },
        },
        {
          title: this.$t('单据类型'),
          dataIndex: 'orderType',
          customRender: (text) => this.mappings.orderType[text] || text,
          width: 120,
        },
        {
          title: this.$t('业务日期'),
          dataIndex: 'bizDate',
          width: 120,
          customRender: (text) => text?.split(' ')[0],
        },
        {
          title: this.$t('单据状态'),
          dataIndex: 'status',
          customRender: (text) => this.receivableOrderStatusMapping[text],
          width: 80,
        },
        {
          title: this.$t('客户'),
          dataIndex: 'customerName',
          width: 100,
        },
        {
          title: this.$t('结算组织'),
          width: 120,
          dataIndex: 'businessUnitName',
        },
        {
          title: this.$t('金额') + this.$t('未含税'),
          width: 120,
          dataIndex: 'amountWithoutTax',
          scopedSlots: { customRender: 'amountWithoutTax' },
        },
        {
          title: this.$t('税额'),
          width: 120,
          dataIndex: 'taxAmount',
          scopedSlots: { customRender: 'taxAmount' },
        },
        {
          title: this.$t('应收金额'),
          dataIndex: 'receivableAmount',
          width: 120,
          scopedSlots: { customRender: 'receivableAmount' },
        },
        {
          title: this.$t('开票金额'),
          dataIndex: 'invoicedAmount',
          width: 120,
          scopedSlots: { customRender: 'invoicedAmount' },
        },
        {
          title: this.$t('能否生成凭证'),
          dataIndex: 'needGenerateVoucher',
          width: 100,
          customRender: (text, record) => {
            const val = record.needGenerateVoucher ?? record.need_generate_voucher
            return val === 1 ? this.$t('需要') : val === 0 ? this.$t('不需要') : ''
          },
        },
        {
          title: this.$t('是否生成凭证'),
          dataIndex: 'voucherGenerated',
          width: 100,
          customRender: (text) => (text ? this.$t('是') : this.$t('否')),
        },
        {
          title: this.$t('是否下推收入成本单'),
          dataIndex: 'incomeCostConfirmPushed',
          width: 120,
          customRender: (text) => {
            if (text === 1 || text === true) return this.$t('是')
            if (text === 0 || text === false) return this.$t('否')
            return ''
          },
        },
        {
          title: this.$t('凭证号'),
          dataIndex: 'voucherNo',
          width: 100,
        },
        {
          title: this.$t('业务单号'),
          dataIndex: 'otherSns',
          width: 250,
          scopedSlots: { customRender: 'otherSns' },
        },
        {
          title: this.$t('源单类型'),
          dataIndex: 'sourceOrderType',
          width: 100,
          customRender: (text) => this.mappings.sourceOrderType[text] || text,
        },
        {
          title: this.$t('源单编码'),
          dataIndex: 'sourceOrderCode',
          width: 220,
          scopedSlots: { customRender: 'sourceOrderCode' },
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          width: 220,
        },
      ]
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    async fetchMappings() {
      this.mappings = await fetchDocumentMappings(this.docType, ['orderType', 'sourceOrderType'])
    },
    copyOrderSn(text) {
      copy(text)
    },
    subtract,
    reset() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.searchHandle(1)
      this.fetchMappings()
    },
    searchHandle(pageNo) {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.$refs.CommonTableRef.queryList(pageNo)
    },
    supplierIndexChange(val) {
      this.formData.supplierName = val.supplierName
    },
    createHandle() {
      this.$router.push({ name: 'receivableDetail' })
    },
    viewDetail(record) {
      this.addPane({
        view: 'receivableManage/receivableDetail/' + record.orderSn,
        name: 'detailSn',
        query: {
          id: record.id,
          sn: record.orderSn,
        },
        route: `/receivableManage/receivableDetail?id=${record.id}&sn=${record.orderSn}`,
      })
    },
    chooseBizDate(date) {
      this.formData.bizDateStart = date.start_time
      this.formData.bizDateEnd = date.end_time
    },
    chooseAccountingDate(date) {
      this.formData.accountingDateStart = date.start_time
      this.formData.accountingDateEnd = date.end_time
    },
    async queryOrderList(params) {
      if (!this.formData.businessUnitCode) return
      let data = {
        ...this.formData,
        ...params,
      }
      let orderSn = spaceToComma(this.formData.orderSn)
      if (orderSn.includes(',')) {
        data.orderSnList = orderSn.split(',')
        delete data.orderSn
      } else if (orderSn) {
        data.orderSn = orderSn
      }
      this.tableLoading = true
      let res = await http({
        type: 'post',
        url: api.getReceivableList,
        data,
      })
      this.tableData = convertKeysToCamelCase(res.result.list || [])
      this.total = res.result.total
      this.tableLoading = false
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    confirmBatchCancel() {
      const invalidRows = this.selectedRows.filter(
        (row) => !['DRAFT', 'WAIT_CHECK', 'WAIT_WRITTEN_OFF'].includes(row.status)
      )
      if (invalidRows.length > 0) {
        this.$message.warning(this.$t('只有草稿、待审核和待核销状态的单据可以作废'))
        return
      }
      this.$confirm({
        title: this.$t('确认操作'),
        content: `${this.$t('是否确认作废已选中的')} ${this.selectedRowKeys.length} ${this.$t(
          '个单据'
        )}？`,
        onOk: () => this.batchCancel(),
      })
    },
    async batchCancel() {
      this.batchCancelLoading = true
      try {
        const promises = this.selectedRowKeys.map((id) =>
          http({
            url: api.operateDoc,
            data: {
              action: 'cancel',
              docType: this.docType,
              idList: [id],
            },
          })
        )
        await Promise.all(promises)
        this.$success({
          title: this.$t('成功'),
          content: this.$t('作废成功'),
        })
        this.searchHandle()
      } catch (err) {
        this.searchHandle()
      } finally {
        this.batchCancelLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css/mixin.scss';
.btnBgc {
  background-color: #0088ff;
  color: #ffffff;
}
</style>
